import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../../utils/cn';

export const INPUT = 'w-full h-9 px-3 bg-white border border-[#D8DDE6] rounded text-[13px] outline-none focus:border-[#0176D3]';
export const LABEL = 'block text-[11px] font-semibold text-[#706E6B] mb-1';
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const localToday = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
export const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
export const errMsg = (e, f = 'Please try again') => e?.response?.data?.message || e?.response?.data?.error || f;

// Downloads a PDF (or any file) from an API path.
export async function downloadFile(path, filename) {
  const api = (await import('../../../services/api')).default;
  const alertService = (await import('../../../utils/alert')).default;
  try {
    const res = await api.get(path, { responseType: 'blob' });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement('a'); a.href = href; a.download = filename; a.click();
    setTimeout(() => URL.revokeObjectURL(href), 1000);
  } catch (e) { alertService.error('Download failed', 'Please try again'); }
}

export function Modal({ title, onClose, children, footer, wide }) {
  return (
    <div className="fixed inset-0 z-[100] bg-black/40 flex items-end sm:items-start justify-center overflow-y-auto sm:p-4" onMouseDown={onClose}>
      <div className={cn('bg-white rounded-t-lg sm:rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.16)] w-full sm:my-8 max-h-[100dvh] sm:max-h-none overflow-y-auto', wide ? 'max-w-4xl' : 'max-w-lg')} onMouseDown={(e) => e.stopPropagation()} role="dialog" aria-label={title}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-[#D8DDE6]">
          <h2 className="text-[15px] font-bold text-[#080707]">{title}</h2>
          <button type="button" onClick={onClose} aria-label="Close" className="p-1 rounded hover:bg-[#F3F2F2]"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-4">{children}</div>
        {footer && <div className="flex justify-end gap-2 px-5 py-3 border-t border-[#D8DDE6] bg-[#FAFAF9] rounded-b-lg sticky bottom-0">{footer}</div>}
      </div>
    </div>
  );
}

export function Btn({ primary, danger, className, ...props }) {
  return (
    <button type="button" {...props}
      className={cn('inline-flex items-center justify-center h-8 px-4 rounded whitespace-nowrap shrink-0 text-[13px] font-semibold disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0176D3] focus-visible:ring-offset-1',
        primary ? 'bg-[#0176D3] text-white hover:bg-[#014486]' : danger ? 'bg-white border border-[#D8DDE6] text-[#BA0517]' : 'bg-white border border-[#C9C9C9] text-[#0176D3] hover:bg-[#F3F3F3]', className)} />
  );
}
